<template>
  <div ref="panel" class="c-panel u-mb" :class="{ 'c-panel--large': isLarge }">
    <div class="c-panel__content">
      <div class="c-panel__figure">
        <div class="c-panel__imgs" ref="gallery">
          <div class="c-panel__img o-cover" @click="openModal(index)" :style="{ 'background-image':'url(' + image.url + ')'}" v-for="(image, index) in images" :key="image.id">
            <div class="c-panel__play-icon" v-if="image.video">
              <img src="@/assets/play.svg" width="77" height="77" alt="Play">
            </div>
          </div>
        </div>
        <div class="c-panel__enlarge-icon">
          <img src="@/assets/plus-white.svg" width="32" height="32" alt="Enlarge">
        </div>
      </div>
      <div class="c-panel__body">
        <div class="c-panel__arrow" v-if="hasArrow">
          <img src="@/assets/arrow-right-blue.svg" width="45" height="45" alt="Right arrow">
        </div>
        <h4 class="c-panel__heading">{{ heading }}</h4>
        <div class="u-st1 u-ff-alt u-italic o-box-off">
          <p>{{ body }}</p>
        </div>
        <div class="u-mt" v-if="images.length > 1">
          <button ref="prev" class="c-panel__btn c-panel__btn--prev" @click="prevImage">
            <img src="@/assets/caret-left-blue.svg" height="32" alt="Left caret">
          </button>
          <button ref="next" class="c-panel__btn c-panel__btn--next" @click="nextImage">
            <img src="@/assets/caret-right-blue.svg" height="32" alt="Right caret">
          </button>
        </div>
      </div>
    </div>
    <div class="c-modal" :class="'modal-' + index" @click="closeModal(index)" v-for="(image, index) in images" :key="image.id" style="display:none">
      <div class="c-modal__item">
        <div class="o-ratio o-ratio--16:9" v-if="image.video">
          <iframe width="560" height="315" :src="'https://www.youtube.com/embed/' + image.video" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
        <img :src="image.url" alt="" v-else>
        <div class="c-modal__close">
          <img src="@/assets/close-white.svg" width="32" height="32" alt="Enlarge">
        </div>
        <div class="c-modal__actions" v-if="images.length > 1">
          <button class="c-modal__btn u-st1" @click="prevModal(index, images.length)">Previous</button>
          <button class="c-modal__btn u-st1" @click="nextModal(index, images.length)">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Siema from 'siema'

export default {
  name: 'Panel',
  props: {
    heading: {
      type: String,
      required: true
    },
    body: {
      type: String
    },
    images: {
      type: Array,
      required: true
    },
    video: {
      type: String
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    hasArrow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalIsActive: false
    }
  },
  mounted () {
    this.initGallery()
  },
  methods: {
    openModal (index) {
      this.$refs.panel.querySelector('.modal-' + index).style.display = ''
    },
    closeModal (index) {
      this.$refs.panel.querySelector('.modal-' + index).style.display = 'none'
    },
    nextModal (index, total) {
      let nextModal = index + 1

      if (nextModal === total) {
        nextModal = 0
      }

      this.$refs.panel.querySelector('.modal-' + index).style.display = 'none'
      this.$refs.panel.querySelector('.modal-' + nextModal).style.display = ''
    },
    prevModal (index, total) {
      let prevModal = index - 1

      if (prevModal < 0) {
        prevModal = total - 1
      }

      this.$refs.panel.querySelector('.modal-' + index).style.display = 'none'
      this.$refs.panel.querySelector('.modal-' + prevModal).style.display = ''
    },
    initGallery () {
      let selector = this.$refs.gallery

      this.mySiema = new Siema({
        selector: selector,
        loop: true,
        draggable: false,
        duration: 800
      })
    },
    prevImage () {
      this.mySiema.resizeHandler()
      this.mySiema.prev()
    },
    nextImage () {
      this.mySiema.resizeHandler()
      this.mySiema.next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Panel.vue